export const modalities = {
  Sprechen: 'Mündliches Benennen',
  Verstehen: 'Auditives Sprachverständnis',
  Schreiben: 'Schriftliches Benennen',
  Lesen: 'Lesesinnverständnis',
};
